// collection page show more categories js
$(window).on("load", function() {
  if(window.matchMedia("(max-width: 1499px)").matches){
    $(".product-grid-container.grid_verticle .grid__item").css({
      "width": "calc(33.33% - 30px* 3 / 4) !important",
      "max-width": "calc(50% - 30px* 3 / 5) !important"
    });
  }

  if(window.matchMedia("(max-width: 1199px)").matches){
    $(".grid_verticle .collection ul li.grid__item").css({
      "width": "calc(50% - 30px* 2 / 2) !important",
      "max-width": "calc(50% - 30px* 0 / 2) !important"
    });
  }

  if(window.matchMedia("(max-width: 945px)").matches){
    $(".grid_verticle .collection ul li.grid__item").css({
      "width": "calc(100% - 30px* 2 / 2) !important",
      "max-width": "calc(100% - 30px* 0 / 2) !important"
    });
  }
});

// --------- js for add class when click on icon full width in collection page start -------------

$(window).on('load', function() {
  // Trigger click on the default element (e.g., ".content_grid")
  $(".content_grid").click();
});
  
$(".content_full").click(function() {  
  $(".facets_icons_grid, .collection #product-grid").addClass("content_full_width");
  $(".facets_icons_grid, .collection #product-grid").removeClass("content_grid_width content_3_column");
});

$(".content_grid").click(function() {
  $(".facets_icons_grid, .collection #product-grid").addClass("content_grid_width");
  $(".facets_icons_grid, .collection #product-grid").removeClass("content_full_width content_3_column");
});

$(".content_3_grid").click(function() {
  $(".facets_icons_grid, .collection #product-grid").addClass("content_3_column");
  $(".facets_icons_grid, .collection #product-grid  ").removeClass("content_full_width content_grid_width");
 
});

// ------------- js for add class when click on icon full width in collection page End ------------

   
    // 	before background remove when click on read more button
     $(".cat-slide-read-more-button p").click(function(){
            $(".cat-slide-read-more").toggleClass("cat-before-background");
        });

    // resize the slide-read-more Div
    var box = $(".cat-slide-read-more .cat_slider_text");
    var minimumHeight =765; // max height in pixels
    var initialHeight = box.innerHeight();
    // reduce the text if it's longer than 200px
    if (initialHeight > minimumHeight) {
        box.css('height', minimumHeight);
        $(".cat-read-more-button").show();
    }
    SliderReadMore();
    function SliderReadMore() {
        $(".cat-slide-read-more-button").on('click', function () {
            // get current height
            var currentHeight = $(this).parent().find(".cat_slider_text").innerHeight();
            // get height with auto applied
            var autoHeight = $(this).parent().find(".cat_slider_text").css('height', 'auto').innerHeight();
            // reset height and revert to original if current and auto are equal
            var newHeight = (currentHeight | 0) === (autoHeight | 0) ? minimumHeight : autoHeight;
            $(this).parent().find(".cat_slider_text").css('height', currentHeight).animate({
                height: (newHeight)
            })
            $(this).parent().find(".cat-slide-read-more-button").toggle();
        });
    }






// Quick Modal
$( document ).ready(function() {
  $(".product-button-eye").click(function() {  
     $('body').addClass("quick-modal");    
  });

  
  $(".quick_modal .close").click(function() {  
    $('body').removeClass("quick-modal");     
  });

// Collection page filer

$(".filter_icon").click(function(){
    $('body').toggleClass("facets_popup");
    $(".facets__form-vertical").toggle();
    
    // If you want to ensure that the class is removed when hiding the element
    if (!$(".facets__form-vertical").is(":visible")) {
        $('body').removeClass("facets_popup");
    }
});
//    $('.color-tooltip').on('change', function() {
//       var selectedValue = $(this).val();
// console.log(this)
//       // Hide all tooltips and show only the selected one
//       // $('.tooltiptext').show();
//       // $('.tooltiptext[data-color="' + selectedValue + '"]').show();
//      console.log(selectedValue)
//      console.log("hyyyyy")
//     });


  
// --------------- Home page banner image slider ---------------
  
  $('.slide_iamgessss').slick({
    draggable: true,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
    dots: true,
    fade: true,
    speed: 500,
    infinite: true,
    cssEase: 'ease-in-out',
    touchThreshold: 100
});


  // ------------- Best seller section in home page --------------

$('.image_section').slick({
  rows:2,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  // autoplaySpeed: 2000,
   responsive: [
      {
          breakpoint: 1601,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            
          }
      },
      {
        breakpoint: 1200,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
            },
      {
          breakpoint: 992,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },
     {
       breakpoint: 768,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
     },
      {
          breakpoint: 575,
          settings: {
                slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true
          }
      }
        ]

    });

// ------------- Feactured collection slider -------

$('.feature-collection .collection_slider ').slick({
  dots: false,
  infinite: true,
   arrows: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]

});
  
  
// ------------ Text with slider section ---------
$('.text-slider').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
   dots: true,
    arrows: false,
  autoplay:false,
});

// ------------ video slider in text -------------------------

//   $('.iamge_section').slick({
//   infinite: true,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//    dots: false,
//     arrows: false,
//   autoplay:true,
// });

  
  //-------------------- testimonial slider --------------------
  $(".test-content").not('.slick-initialized').slick({
     arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          autoplay: true
        }
      }
    ]
  });
  
  // let totalSlides = $(".test-content").slick("getSlick").slideCount;
  // $(".total-slides").text(totalSlides);
  // $(".test-content").on("afterChange", function (event, slick, currentSlide) {
  //   $(".current-slide").text(currentSlide + 1);
  // });
  
  // ------------- home page logo section js ----------------
  $('.brands_image').not('.slick-initialized').slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
            autoplay: true,
          dots: false
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
            autoplay: true,
          dots: false
        }
      },
          {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
            autoplay: true
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots:false,
          slidesToShow: 2,
          slidesToScroll: 2,
            autoplay: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          autoplay: true,
          dots:false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  //-------------------- social-slider --------------------
  $(".social_box").not('.slick-initialized').slick({
    arrows: false,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
   
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true
        },
      },
    ],
  });

  
    // ------------ js for scroll to top start ---------------------
  
    $('#scrollToTopBtn').on('click', function() {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
  
    // ------------- js for scroll to top End --------------------
  
  // ------------ js for counter statistics start ------------------
    $('.counting').each(function() {
      var $this = $(this),
          countTo = $this.attr('data-count');
      
      $({ countNum: $this.text()}).animate({
        countNum: countTo
      },
      {
        duration: 3000,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
          //alert('finished');
        }
      });  
    });
  // ------------ js for counter statistics end ---------------

  // --------------- js for Designer team Slider start -------------
  
    $(".designer_slider").not('.slick-initialized').slick({
      arrows: false,
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      // autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  // ------------- js for Designer team Slider end ------------

  // ----------------- Product images slider start --------------

//   $(document).ready(function() {
//   // Horizontal Thumbnail Slider
//   $('.horizontal-thumbnail .product_slider').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     fade: true,
//    asNavFor: '.horizontal-thumbnail .thumbnail-list',
//     responsive: [
//       {
//         breakpoint: 751,
//         settings: "unslick"
//       }
//     ]
//   });

// var $productSlider = $('.horizontal-thumbnail .product_slider');
// var $thumbnailList = $('.horizontal-thumbnail .thumbnail-list');

// if ($productSlider.length >= 0 && $thumbnailList.length >= 1) {
//   console.log("if condition")


//   $('.horizontal-thumbnail .thumbnail-list').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     asNavFor: '.horizontal-thumbnail .product_slider',
//     arrows: true,
//     dots: false,
//     focusOnSelect: true,
//     responsive: [
//       {
//         breakpoint: 751,
//         settings: "unslick"
//       }
//     ]
//   });
// } else {
//   console.log("else condition")
//   $(".horizontal-thumbnail .product_slider, .horizontal-thumbnail .thumbnail-list").slick('unslick');
// }

// });
  // --------------- Product images slider End -----------------         


  // ------------- Sticky product in product page start -----------------
    var $stickyProduct = $('.sticky_product');
    var windowHalfHeight = $(window).height() / 2;
  
    $(window).on('load scroll', function() {
      // var st = $(this).scrollTop();
  
      // if (st > windowHalfHeight) {
      //   $stickyProduct.removeClass('sticky-hidden').addClass('sticky-visible');
      // } else {
      //   $stickyProduct.removeClass('sticky-visible').addClass('sticky-hidden');
      // }
      // $(".close-button p").on("click", function() {
      //    $('.close-button').toggleClass('close-toggle');
      //     $('.sticky_product').slideUp();
      // });

      $('.select__select').on('change', function () {
        // alert("hyy")
          var selectedValue = $(this).val();
          var variantName = $(this).data('variant'); // Assuming you have a data attribute to identify the variant
        
      
          // Update corresponding radio buttons based on the selected variant
          $('input[name="' + variantName + '"]').prop('checked', false);
          $('input[name="' + variantName + '"][value="' + selectedValue + '"]').prop('checked', true);
        });
      
          $('.product-form__input label:first').click();
      
            
      $('.product-form__input').on('click', 'label', function () {
      
          // Get the 'for' attribute of the clicked label
          var forValue = $(this).attr('for');
         
          // Find the corresponding radio button based on the 'for' attribute
          var correspondingRadio = $('input[id="' + forValue + '"]');
      
          // Get the value of the corresponding radio button
          var radioValue = correspondingRadio.val();
          $("#tool").text(radioValue)
         
          // Get the variant name based on the radio button
          var variantName = correspondingRadio.attr('name');
      
          // Update corresponding dropdown based on the clicked label and variant
          $('select[name="options[' + variantName + ']"]').val(radioValue);
      });


      
      // ------------- Sticky product in product page start -------------

    });
  // --------------- Sticky product in product page End ----------


  // Newsletter popup start
  // Function to display the popup after 5 seconds
  function showPopup() {
    $('.news-letter-popup').show();
    $('body').addClass('popup-open'); // Add class to disable scrolling
  }

  function closePopup() {
    $('.news-letter-popup').hide();
    $('body').removeClass('popup-open'); // Remove class to enable scrolling
  }

  setTimeout(showPopup, 2000); // Show popup after 5 seconds

  // Close popup when close button is clicked
  $(".news-letter-close-button").on("click", function() {
    closePopup();
  });
  // ----------------- Newsletter popup End -------------
});


// -------- cart drawer -------------


$(".product-form__submit").click(function(){

  const cart_id = this.form.querySelector('[name=id]').value;
  //console.log("casrttttttt",cart_id)
         $('.temp_message-'+ cart_id).text('Item added to Cart')
	//$(".drawer").addClass("animate active");
})

// ------------ account page click title then change text


$(document).ready(function() {
    $('.content-button').on('click', function() {
        $('.content-button').removeClass('active'); // Remove 'active' class from all buttons
        $(this).addClass('active'); // Add 'active' class to the clicked button

        $('.content').hide(); // Hide all content sections
        var targetContent = $(this).data('target'); // Get the target content ID
        $('#' + targetContent).show(); // Show the selected content based on the button clicked
    });

    // Trigger click event on the first button to set it as active by default
    $('.content-button.active').trigger('click');
});




// Facets js


 // $('.submenu_apply_button ').click(function(e) {
	// console.log("Click Apply Button");
 //   $(".mobile-facets .mobile-facets__main").removeClass("submenu-open");
 //   console.log("Remove Class")
// });



$(document).ready(function() {
  $(document).on('ajaxCart:productAdded', function(event) {
    // Show the notification message when a product is added to the cart
    var notification = $('.cart-drawer-notification');
    if (notification.length) {
      notification.css('display', 'block');
      setTimeout(function() {
        notification.css('display', 'none');
      }, 5000); // Hide the notification after 5 seconds
    }
  });
});

// trending-collection section 
$(document).ready(function() {
  $('.trending_image_block').slick({
    dots: true,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });
});
